import React, { useState } from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";

const RescheduleTaskModal = ({
  closeModal,
  setShowModal,
  setShowTaskCompleted,
  setShowRescheduledTask,
  setShowRescheduleSuccess,
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const handleSaveOfRescheduleTask = () => {
    setShowModal(false);
    setShowTaskCompleted(false);
    setShowRescheduledTask(false);
    setShowRescheduleSuccess(true);
  };
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[25%]">
        <div className="flex flex-col ">
          <div
            className="cursor-pointer absolute right-3 top-4"
            onClick={closeModal}
          >
            <img src={cross_icon} alt="cross icon" />
          </div>

          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Reschedule Task</div>
          </div>
          <div className="text-[12px] text-[#828282] mt-6">
            Currently Assigned to:{" "}
            <span className="text-black">Rahul Sharma</span>
          </div>
          <div className="flex justify-between mt-6">
            <div className="text-[12px] text-[#828282]">
              Current Task: Follow Up (Call)
            </div>
            <div>
              <img
                src={edit_pencil_icon}
                className="cursor-pointer"
                alt="edit pencil"
              />
            </div>
          </div>
          <div className="mt-6">Transfer to</div>
          <div>
            <select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="border border-[#2F80ED] p-2 w-full rounded-lg"
            >
              <option value="" disabled hidden>
                Search & select the person
              </option>
              <option value="person1">Amit Gupta</option>
              <option value="person2">Rohit Mehta</option>
            </select>
          </div>
          <div className="flex justify-between mt-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={closeModal}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={handleSaveOfRescheduleTask}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RescheduleTaskModal;
